const errorMsgConfig = {
    '10086': '系统繁忙',
    '3123':'设备离线，请检查网络',
    '5001': '二维码过期，请重新扫码',
    '7001': '客户端不存在或者没有请求授权',
    '3000': '登录过期',
    '3106': '登录被踢',
    // '20001': '暂无信息',
    // '20002': '添加失败',
    // '20003': '修改失败',
    // '20004': '删除失败',
}

const APP_PROTOCOL_URL = {
    'IOS':'CloudyCommunityApp://',
    'ANDROID':'cloudcommunityapp://'
  }

export {
    errorMsgConfig,
    APP_PROTOCOL_URL
}


// WEBPACK FOOTER //
// ./src/utils/config.js